export const WELCOME_VIDEO_ALIAS = "welcome_video_watched";
export const JOIN_FB_GROUP_ALIAS = "joined_facebook_group";
export const QUESTIONNAIRE_COMPLETED_ALIAS = "questionnaire_completed";
export const MEETING_SCHEDULED_ALIAS = "meeting_scheduled";

export const FB_GROUP_URL = "https://www.facebook.com/groups/776610176229727";

export const WEBINAR_VIDEO = "webinar_video";
export const WELCOME_VIDEO = "welcome_video";
export const PROMOTE_VIDEO = "promote_video";

export const MASTER_FUNNEL = "master";
export const BLUEPRINT_FUNNEL = "blueprint";
export const GUEST_USER_FUNNEL = "guest_user";
export const EXCLUSIVE_MEMBER = "exclusive_member";
export const DOLLAR_TRIAL_FUNNEL = "dollar_trial_funnel";
export const LIVE_OPT_CALL_FUNNEL = "live_opportunity_call";
export const CARD_FREE_TRIAL_FUNNEL = "card_free_trial_funnel";

export const MAX_CALENDAR_EVENTS_PER_DAY = 7;

export const VIMEO = "vimeo";
export const WISTIA = "wistia";

export const MAX_PROFILE_AVATAR_SIZE = 5242880; //in bytes
export const MAX_VIDEO_SIZE_MB = 25; // Maximum size for video in MB
export const MAX_VIDEO_SIZE_BYTES = 26214400; // Convert MB to bytes

export const ENAGIC = "Enagic";
export const TRIFECTA = "Trifecta";
export const CORE = "Core";
export const ADVISOR = "Advisor";
export const ACTIVE_RECRUITER = "Active-Recruiter";

export const GUEST_BADGE = "Guest";
export const ENAGIC_BADGE = "Enagic";
export const TRIFECTA_BADGE = "Trifecta";
export const ADVISOR_BADGE = "Advisor";

export const CHATROOM = "chatroom";
export const DEFAULT_COMMUNITY = "default";

export const GUSET_USER_DESCRIPTION =
  "Get Guest User Access with Limited Access to RaceTo Freedom";
export const SEVEN_DAYS_FREE_TRIAL_DESCRIPTION =
  "Free Trial Orderform With A Card Signup For 7 Days, Then $37 A Month";
export const $1_TRIAL_DESCRIPTION =
  "$1 Trial Orderform to RaceToFreedom for 7 Days, Then $37 A Month";
export const EXCLUSIVE_MEMBER_ADMIN_DESCRIPTION =
  "Get Exclusive Discounted/ Membership for $97 for First Year.";
export const ONE_HOURMASTER_CLASS_DESCRIPTION =
  "7 days Free Trial Without A Card Signup To 1 Hour Master Class For 7 Days, Then $37 A Month";
export const LIVE_OPPORTUNITY_CALL_DESCRIPTION =
  "7 days Free Trial Without A Card Signup To Live Opportunity Call For 7 Days, Then $37 A Month";
export const NINETY_DAY_INTRO_DESCRIPTION =
  "$97 for 90 days, Then goes $37 a month after 90 days";
export const FIVE_MONTH_INTRO_DESCRIPTION =
  "$149 for 5 months, Then goes to $37 a month after 5 months";
export const ANNUAL_SPECIAL_DESCRIPTION =
  "Special Bundle Annual Link - Just $370/Year";
export const FREE_REGISTRATION_DESCRIPTION =
  "7 Days Free Trial Without A Card Signup to 1 Hour Master Class for 7 Days, Then $37 A Month.";
export const INSTANT_SIGNUP_PAYMENT_DESCRIPTION = 
  "Instant $37 Payment - Immediate Access to All Content, Then $37 A Month.";